import React, { useEffect } from 'react'
import moment from 'moment'

import { Box, Grid, Typography } from '@material-ui/core'

import useProfileContext from 'src/context/ProfileContext'
import { Sku } from 'src/api/models'
import { Barcode } from '../Barcode'

interface Props {
  obj: Sku
  onReadyToPrint?: () => void
}

export const SKULabel = ({ obj, onReadyToPrint }: Props) => {
  const barcode = { barcode: obj.guid, type: 'datamatrix', displayName: '' }
  const { profile } = useProfileContext()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className="always-page-break">
      <Box pl={5} pt={5} className="print-page">
        <Grid container justify="center" alignItems="center" spacing={2}>
          <Grid item xs={4}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item xs={8} container justify="center" alignItems="center" spacing={2}>
            <Grid item xs={12}>
              <obj.icon fontSize="large" />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h1">{obj.sku}</Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h1">{obj.guid}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>Printed on {moment().format('lll')}</Typography>
          </Grid>
          {!!profile && (
            <Grid item xs={12}>
              <Typography>By {`${profile.fullName} <${profile.email}>`}}</Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </div>
  )
}
